const UPDATE_CURRENT_ACCOUNT = 'UPDATE_CURRENT_ACCOUNT'
const UPDATE_PREV_PAGE = 'UPDATE_PREV_PAGE'
const initial_state = {
 
}
const currentAccountReducer = (state = initial_state, action) => {
  switch (action.type) {
    case UPDATE_CURRENT_ACCOUNT: {
      // console.log(action)
      return {
        ...state,
        accountId: action.accountId,
        auth: action.auth
      };
    }

    case UPDATE_PREV_PAGE: {
      // console.log(action)
      return {
        ...state,
       prevPage: action.prevPage,
      };
    }

    default: {
      return state;
    }
  }
}

export default currentAccountReducer;

